import Model from '../models/model';

const model = new Model({
	name: 'TagActivity',
	api: 'TagActivity',
	title: 'TagActivity',
	idProperty: 'lastSeenDateTime',
	formTitleField: 'peakRSSI',
	readOnly: true,
	disableDelete: true,
	disableAdd: true,
	showGridRefreshBtn: true,
	columns: [
		{ field: 'antennaName', header: 'AntennaName', width: 500 },
		{
			field: 'lastSeenDateTime',
			header: 'TimeStamp',
			type: 'dateTime',
			width: 250,
			filterType: 'dateTime',
			showSecond: true,
			isLocal: true
		},
		{ field: 'peakRSSI', header: 'Rssi' }
	]
});

export default model.createFormBase();
